import { createBasePlugin } from 'wix-rich-content-plugin-commons';
import { VERTICAL_EMBED_TYPE } from './types.js';
import VerticalEmbedComponent from './vertical-embed-component.js';
import createToolbar from './toolbar/createToolbar.js';
import 'react';
import 'prop-types';
import 'wix-rich-content-common';
import 'wix-rich-content-common/dist/statics/schemas/vertical-embed.schema.json';
import 'classnames';
import './CardContent-f61e174e.js';
import './style-inject.es-746bb8ed.js';
import 'wix-rich-content-common/libs/Tooltip';
import './verticalsDataBuilder.js';
import './constants.js';
import 'ricos-schema';
import './convertDuration.js';
import 'lodash';
import './components/Card.js';
import 'wix-rich-content-common/libs/imageUtils';
import './toolbar/inline-buttons.js';
import 'wix-rich-content-editor-common';
import './toolbar/ModalCustomStyles.js';
import './toolbar/VerticalEmbedInputModal.js';
import './toolbar/VerticalEmbedInsertModal.js';
import 'wix-rich-content-ui-components';
import './ItemsList-2febaa8a.js';
import './toolbar/itemsList/Item.js';
import './icons/ReplaceIcon.js';
import './toolbar/insert-buttons.js';
import './icons/Product.js';
import './icons/Event.js';
import './icons/Booking.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const createVerticalEmbedPlugin = (config) => {
  const type = VERTICAL_EMBED_TYPE;
  const _a = config, {
    helpers,
    theme,
    t,
    [type]: settings = {},
    isMobile,
    locale,
    localeContent,
    experiments
  } = _a, rest = __objRest(_a, [
    "helpers",
    "theme",
    "t",
    __restKey(type),
    "isMobile",
    "locale",
    "localeContent",
    "experiments"
  ]);
  return createBasePlugin(__spreadValues({
    component: VerticalEmbedComponent,
    settings,
    theme,
    type,
    toolbar: createToolbar({
      settings,
      helpers,
      t,
      isMobile,
      locale: localeContent || locale,
      experiments
    }),
    helpers,
    t,
    defaultPluginData: {},
    isMobile,
    locale: localeContent || locale
  }, rest));
};
createVerticalEmbedPlugin.functionName = VERTICAL_EMBED_TYPE;

export { createVerticalEmbedPlugin };
//# sourceMappingURL=createVerticalEmbedPlugin.js.map
